"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvSpecificConfig = getEnvSpecificConfig;
exports.getGaCode = getGaCode;
exports.makeFetchActions = void 0;

var _reduxActions = require("redux-actions");

var _index = require("../index");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Retrieves environment specific configuration
 *
 * @param {Object} data
 * @param {String} domain
 * @param {String} brand
 * @return {String}
 */
function getEnvSpecificConfig(data, domain) {
  var brand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  // check if there is a data for specific domain
  if (data[domain]) {
    return data[domain];
  } // same but without www. variant


  var wwwlessdomain = domain.replace('www.', '');

  if (data[wwwlessdomain]) {
    return data[wwwlessdomain];
  } // get brand specific code


  return data[brand] ? data[brand] : null;
}
/**
 * Returns domain specific GA code
 *
 * @param {String} domain
 * @returns {String|null}
 */


function getGaCode(domain) {
  var _getConfig = (0, _index.getConfig)(),
      DEFAULT_BRAND = _getConfig.DEFAULT_BRAND,
      GA_CODES_BY_ENV = _getConfig.GA_CODES_BY_ENV;

  return getEnvSpecificConfig(GA_CODES_BY_ENV, domain, DEFAULT_BRAND);
}
/**
 * Creates fetch actions
 *
 * @param {String} prefix
 * @returns {{}}
 */


var makeFetchActions = function makeFetchActions(prefix) {
  var methods = ['request', 'success', 'error', 'clear'];
  return methods.reduce(function (acc, method) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, method, (0, _reduxActions.createAction)("".concat(prefix, ".").concat(method.toUpperCase()))));
  }, {});
};

exports.makeFetchActions = makeFetchActions;